var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInformation = function SvgIconInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#035F48",
    fillRule: "evenodd",
    d: "M11 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18M0 11C0 4.925 4.925 0 11 0s11 4.925 11 11-4.925 11-11 11S0 17.075 0 11m13 6h-1a2 2 0 0 1-2-2v-4H9V9h1a2 2 0 0 1 2 2v4h1zM12 6.5a1 1 0 1 0-2 0V7a1 1 0 1 0 2 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconInformation;